var cookie = require('react-cookie');
var constants = require('../constants');
var api = require('../../../utils/api');
var routerActions = require('react-router-redux').routerActions;
var loginUtils = require('../loginUtils');
var authCurrentUserActions = require('./auth-current-user');
var commonActions = require('../../common/actions/common');

var Login = (function() {

    var _loginRequest = function() {
        return {
            type: constants.AUTH_LOGIN_REQUEST
        };
    }

    var _loginSuccess = function(data, recordEvent, analyticsLabelSuffix) {
        cookie.save('mgih_at', data.access_token, { path: '/', maxAge: 60 * 60});
        cookie.save('mgih_at_refresh', data.refresh_token, { path: '/', maxAge: 60 * 60 * 24 * 30});

        var result = {
            type: constants.AUTH_LOGIN_SUCCESS,
            data: data
        };

        recordEvent = recordEvent !== false;

        if(recordEvent){
            result.meta = {
                analytics: {
                    eventType: constants.AUTH_LOGIN_SUCCESS,
                    actionValue: 'Success',
                    labelValue: 'Email' + (analyticsLabelSuffix ? ' ' + analyticsLabelSuffix : '')
                }
            }
        }

        return result;
    }

    var _loginError = function(error, analyticsLabelSuffix) {
        return {
            type: constants.AUTH_LOGIN_FAILURE,
            errors: error.data,
            meta: {
                analytics: {
                    eventType: constants.AUTH_LOGIN_FAILURE,
                    actionValue: 'Failure',
                    labelValue: 'Email' + (analyticsLabelSuffix ? ' ' + analyticsLabelSuffix : '')
                }
            }
        };
    }

    var _validationError = function(error){
        return {
            type: constants.AUTH_LOGIN_FAILURE,
            errors: error
        }
    }

    var _clearLoginError = function() {
        return {
            type: constants.CLEAR_LOGIN_ERROR
        };
    }

    var _login = function(email, password, redirectUrl, analyticsLabelSuffix) {
        return function(dispatch) {
            loginUtils.validate(email, password)
                .then(function(result) {
                    if (result === true) {
                        dispatch(_loginRequest());
                        api.post('/proxy/oauth/token', {
                                "username": email,
                                "password": password,
                                "grant_type": "password"
                            })
                            .then(function(data) {
                                dispatch(_loginSuccess(data, true, analyticsLabelSuffix));
                                dispatch(authCurrentUserActions.fetchCurrentUser(data.access_token));

                                if(redirectUrl !== 'no-redirect'){
                                    if(redirectUrl){
                                        dispatch(routerActions.replace(redirectUrl));
                                    }else{
                                        dispatch(routerActions.replace('/education'));
                                    }
                                }
                            })
                            .catch(function(error) {
                                if(error.response){
                                    if(error.response.data.error === 'invalid_grant'){
                                        error.response.data.error_description = 'The username and password you entered did not match our records. Please double-check and try again.';
                                    }

                                    dispatch(_loginError(error.response, analyticsLabelSuffix));
                                }else{
                                    dispatch(commonActions.setGenericError('', error.message));
                                }
                            })
                    } else {
                        dispatch(_validationError(result));
                    }
                })
        };
    }

    var _setLoginRedirectUrl = function(redirectUrl){
        return {
            type: 'SET_LOGIN_REDIRECT_URL',
            loginRedirectUrl: redirectUrl
        };
    }

    var _clearLoginRedirectUrl = function(){
        return {
            type: 'CLEAR_LOGIN_REDIRECT_URL'
        };
    }

    return {
        login: _login,
        loginSuccess: _loginSuccess,
        clearLoginError: _clearLoginError,
        setLoginRedirectUrl: _setLoginRedirectUrl,
        clearLoginRedirectUrl: _clearLoginRedirectUrl
    }
})();

module.exports = Login;



// WEBPACK FOOTER //
// ./src/common/modules/auth/actions/auth-login.js